import Icon from 'components/Icon';
import styled from 'styled-components';
import { green, white } from 'utils/style/colors';

export const StyledIcon = styled(Icon)`
  color: ${green};
  cursor: pointer;
  padding: 0.5rem;
  font-size: 20px !important;
  transition: 0.3s all ease;
  font-weight: 500 !important;
  border-radius: 50%;
  :hover {
    color: ${white};
    background-color: ${green};
  }
`;
